import {
  fetchAllEmailCampaigns,
  fetchEmailCampaignById,
  fetchEngagementMetricsByCampaignId,
  fetchLineGraphMetricsByCampaignId,
  fetchRecipientsByCampaignId,
  fetchRecipientStatsByCampaignId,
} from '../routines/emailCampaignRoutine';

const initialState = {
  campaigns: [],
  campaignsLoading: false,
  campaign: {},
  campaignLoading: false,
  recipients: [],
  recipientsLoading: false,
  recipientStats: {},
  recipientStatsLoading: false,
  engagementMetrics: {},
  engagementMetricsLoading: false,
  lineGraph: [],
  lineGraphLoading: false,
};

const emailCampaignReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchAllEmailCampaigns.TRIGGER: {
      return {
        ...state,
        campaignsLoading: true,
      };
    }
    case fetchAllEmailCampaigns.SUCCESS: {
      return {
        ...state,
        campaigns: action.payload,
        campaignsLoading: false,
      };
    }
    case fetchAllEmailCampaigns.FAILURE: {
      return {
        ...state,
        campaigns: [],
        campaignsLoading: true,
      };
    }
    case fetchEmailCampaignById.TRIGGER: {
      return {
        ...state,
        campaignLoading: true,
      };
    }
    case fetchEmailCampaignById.SUCCESS: {
      return {
        ...state,
        campaign: action.payload,
        campaignLoading: false,
      };
    }
    case fetchEmailCampaignById.FAILURE: {
      return {
        ...state,
        campaign: {},
        campaignLoading: true,
      };
    }
    case fetchRecipientsByCampaignId.TRIGGER: {
      return {
        ...state,
        recipientsLoading: true,
      };
    }
    case fetchRecipientsByCampaignId.SUCCESS: {
      return {
        ...state,
        recipients: action.payload,
        recipientsLoading: false,
      };
    }
    case fetchRecipientsByCampaignId.FAILURE: {
      return {
        ...state,
        recipientsLoading: false,
      };
    }
    case fetchRecipientStatsByCampaignId.TRIGGER: {
      return {
        ...state,
        recipientStatsLoading: true,
      };
    }
    case fetchRecipientStatsByCampaignId.SUCCESS: {
      return {
        ...state,
        recipientStats: action.payload,
        recipientStatsLoading: false,
      };
    }
    case fetchRecipientStatsByCampaignId.FAILURE: {
      return {
        ...state,
        recipientStatsLoading: false,
      };
    }
    case fetchEngagementMetricsByCampaignId.TRIGGER: {
      return {
        ...state,
        engagementMetricsLoading: true,
      };
    }
    case fetchEngagementMetricsByCampaignId.SUCCESS: {
      return {
        ...state,
        engagementMetrics: action.payload,
        engagementMetricsLoading: false,
      };
    }
    case fetchEngagementMetricsByCampaignId.FAILURE: {
      return {
        ...state,
        engagementMetricsLoading: false,
      };
    }
    case fetchLineGraphMetricsByCampaignId.TRIGGER: {
      return {
        ...state,
        lineGraphLoading: true,
      };
    }
    case fetchLineGraphMetricsByCampaignId.SUCCESS: {
      return {
        ...state,
        lineGraph: action.payload,
        lineGraphLoading: false,
      };
    }
    case fetchLineGraphMetricsByCampaignId.FAILURE: {
      return {
        ...state,
        lineGraphLoading: false,
      };
    }
    default:
      return state;
  }
};

export default emailCampaignReducer;
